<div class="detailFirstColumn">
      <label class="col-form-label">
        {{ field.label }}
      </label>
    </div>
    <div>
      <p class="text-primary font-small-3 mb-0">
        {{ (field?.value | extractSenderDetailPipe)?.user?.name }}
      </p>
    </div>